export default {"src":"/_next/static/media/auth.f46c0b5d.svg","height":498,"width":520};